import { useEffect, useState } from "react";
import { getCarOrders } from "../services/useService";
import { Order } from "src/shared/services/interfacev2";
import { useUser } from "src/shared/context/UserContext";

export const useCarOrders = (page: number, rowsPerPage: number, filter: string, selectedDate: string, selectedDate2: string, searchQuery: string) => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { userConfigration } = useUser();
  const [pageSize, setPageSize] = useState(userConfigration?.tableDefaultSize || 10);

  useEffect(() => {
    setPageSize(userConfigration?.tableDefaultSize || 10);
  }, [userConfigration]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);

        const finalSelectedDate = filter === "CustomizeDate" ? selectedDate : "";
        const finalSelectedDate2 = filter === "CustomizeDate" ? selectedDate2 : "";

        const response = await getCarOrders(page + 1, pageSize, searchQuery, filter, finalSelectedDate, finalSelectedDate2);

        if (response?.result) {
          // Transform the data to include id field
          const transformedOrders: Order[] = response.result.map((order: any) => ({
            ...order,
            id: order.Orderid,
          }));

          setOrders(transformedOrders);
          setTotalCount(response.totalRecords || response.totalCount || 0);
        } else {
          setOrders([]);
          setTotalCount(0);
        }
      } catch (err) {
        setError("Failed to fetch orders. Please try again later.");
        console.error("Error fetching orders:", err);
        setOrders([]);
        setTotalCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [page, rowsPerPage, filter, selectedDate, selectedDate2, searchQuery]);

  return {
    orders,
    totalCount,
    loading,
    error,
  };
};
